import { Col, Row } from 'react-bootstrap';
import styled, { keyframes } from 'styled-components';
import { BOLD_FONT_WEIGHT, DEFAULT_PADDING, PRIMARY_COLOR, SM_FONT_SIZE, XL_PADDING, XXL_FONT_SIZE } from '../../Common/StyleElement';

const float = keyframes`
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
}
`

export const HeroImage = styled.img`
    height: auto;
    width: 350px;
    animation: ${float} 6s ease-in-out infinite;
    img {
        width: 100%;
        height: auto;
    }
`

export const HeroBody = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    flex-direction: column;
`

export const HeroTitle = styled.h1`
    font-size: ${XXL_FONT_SIZE};
    font-weight: ${BOLD_FONT_WEIGHT};
    padding-bottom: ${DEFAULT_PADDING};
    text-align: left;
`

export const HeroText = styled.p`
    font-size: ${SM_FONT_SIZE};
`

export const HeroCol = styled(Col)`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: ${props => props['flex-direction'] === 'row' ? 'row' : 'column'};
`

export const HeroRow = styled(Row)`
    padding-bottom: ${XL_PADDING};
`

export const HeroBtns = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;

    a {
        margin: 0 1rem;
    }
`

const wheel = keyframes`
  	to {
		opacity: 0;
		top: 20px;
	}
`;

export const Indicator = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const IndicatorField = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	width: 300px;
`

export const Mouse = styled.div`
	width: 22px;
	height: 40px;
	border: 2px solid ${PRIMARY_COLOR};
	border-radius: 50vh;
	position: relative;
	&::before {
		content: '';
		width: 15px;
		height: 15px;
		position: absolute;
		top: 5px;
		left: 50%;
		transform: translateX(-50%);
		background-color: ${PRIMARY_COLOR};
		border-radius: 50%;
		opacity: 1;
		animation: ${wheel} 2s infinite;
		-webkit-animation: ${wheel} 2s infinite;
	}
`